export default __webpack_public_path__ + "static/media/angpao-bm.711bf76c.webp";